import React, { FunctionComponent, useState, useEffect, useMemo, useCallback } from 'react';

import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { trackPromise } from 'react-promise-tracker';

import { Overlay } from 'core/overlay/Overlay';
import { Select } from 'core/select/Select';
import { FacebookLocale } from 'social/publisher/Publisher.types';
import { fetchFacebookLocales } from 'social/publisher/PublisherFetchers';

interface Props {
    locales: FacebookLocale[] | undefined;
    tenantId: number | undefined;
    save: any;
}
type Option = {
    value: number;
    label: string;
};
const OVERLAY_AREA = 'social-publisher-post-target-languages';

export const LanguageField: FunctionComponent<Props> = ({ locales, tenantId, save }) => {
    const { t } = useTranslation(['social/publisher']);
    const [facebookLocales, setFacebookLocales] = useState<FacebookLocale[]>([]);
    const options = useMemo(
        (): Option[] =>
            facebookLocales.map((el) => {
                return { value: el.key, label: el.name };
            }),
        [facebookLocales],
    );
    let selectedOptions: Option[] = [];

    if (locales && locales.length > 0) {
        const localeKeys = locales.map((el) => el.key);

        selectedOptions = _.filter(options, (el) => _.includes(localeKeys, el.value));
    }

    const handleLocalesChange = (selectedOptions: Option[]): void => {
        const newLocales: FacebookLocale[] = [];

        if (selectedOptions && selectedOptions.length > 0) {
            selectedOptions.forEach((option) => {
                const selectedLocale = _.find(facebookLocales, (locale) => locale.key === option.value);

                if (selectedLocale) {
                    newLocales.push(selectedLocale);
                }
            });
        }
        save(newLocales);
    };

    const loadLocales = useCallback(async () => {
        const data = await trackPromise(fetchFacebookLocales(tenantId), OVERLAY_AREA);

        if (data) {
            setFacebookLocales(data);
        }
    }, [tenantId]);

    useEffect(() => {
        loadLocales();
    }, [loadLocales]);
    return (
        <>
            <Overlay area={OVERLAY_AREA} />
            <Select
                name="languages"
                className="languages-select"
                options={options}
                value={selectedOptions}
                onChange={handleLocalesChange}
                isMulti
                placeholder={t('SELECT')}
            />
        </>
    );
};
